import React from 'react';
import { View, Text, TextInput, TextButton } from '../react-native/reactNativeWrappers';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import { query } from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import InputHeader from '../common/FormComponents/InputHeader';
import Input from '../common/FormComponents/InputStyle';
import checkPromoCodeQ from './checkPromoCodeQ';

@inject('userStore')
@observer
export default class ApplyPromoCode extends React.Component {
  @observable promoCode = '';
  @observable error = null;
  @observable success = false;

  applyPromo = async () => {
    if (this.promoCode) {
      try {
        const codeCheck = await query(checkPromoCodeQ, { code: this.promoCode });
        this.processCheck(codeCheck);
      } catch (err) {
        this.error = err;
      }
    }
  };

  @action.bound
  processCheck(codeCheck) {
    const promoCode = getp(codeCheck, 'data.promo_code.0');
    const promoCodeUsed = getp(codeCheck, 'data.user_used_promo_code.0');
    if (promoCode && !promoCodeUsed) {
      //the code is filtered at a server layer to prevent querying for codes, need to re-add it
      promoCode.code = this.promoCode;
      //promo code is valid
      if (this.props.onSuccess) {
        this.props.onSuccess(promoCode);
        this.success = true;
      }
      this.error = '';
    } else if (!promoCode) {
      //invalid promo code
      this.error = 'This promo code is invalid';
    } else if (promoCodeUsed) {
      //Already used this code
      this.error = 'You have already used this code';
    }
  }

  render(props) {
    return (
      <View>
        <View styles="f-columns f-start-end">
          <View>
            <InputHeader label="Promo Code" error={this.error} />
            <Input
              onChange={e => (this.promoCode = e.target.value)}
              value={this.promoCode}
              placeholder="PROMO"
              className="brad-tr-none brad-br-none"
            />
          </View>
          <View>
            <TextButton onPress={this.applyPromo} styles="brad-tl-none brad-bl-none h-48 mt-s">
              Apply
            </TextButton>
          </View>
        </View>
        <View if={this.success}>
          <Text styles="green">Success!</Text>
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/Payment/ApplyPromoCode.js